module.exports = __webpack_public_path__ + "static/better-mortgage-press-kit-102618-e4005a17f00d83e6ee76acf0f0543c72.pdf";